import ResourceList from '../../../components/admin/ResourceList'
import ContactCard from '../clients/ContactCard'

function AdminTimesheetsUserList({ enablePullToRefresh }) {
    return (
        <div>
            <ResourceList
                enablePullToRefresh={enablePullToRefresh}
                apiUrl={'/v1/timesheets/timesheets-users'}
                itemClickPath={'/users/:item.id/timesheets'}
                fields={[
                    {
                        column: 1,
                        getValue: (item) => <ContactCard user={item} summary />,
                    },
                ]}
            />
        </div>
    )
}

export default AdminTimesheetsUserList
